import { State } from '../../types'

type IndicatorsState = State & {
    indicators: Map<string, any[]>
}

function emptyState(): IndicatorsState {
    return {
        start: { info: { span: { normalized: '' } } },
        indicators: new Map<string, any[]>(),
        span: { begin: 0, end: 0 }
    }
}

const ignore = ['positive_fit', 'zero_fit']

export default function rigIndicatorsReducer(state: IndicatorsState = emptyState(), event: Event): IndicatorsState {
    switch (event?.type) {
        case 'start':
            state = emptyState()

            return state
        case 'event':
            for (const it of event.events) {
                const timestamp = it.timestamp
                for (const [key, value] of Object.entries(it.indicators)) {
                    if (ignore.indexOf(key) != -1) continue
                    if (state.indicators.has(key)) {
                        const channels = state.indicators.get(key)
                        const tail = channels[channels.length - 1]
                        if (tail[1] != value) {
                            channels.push([timestamp, value])
                        }
                    } else {
                        state.indicators.set(key, [[timestamp, value]])
                    }
                }
            }

            return state
        case 'span':
            state.span = event.events

            return state
        default:
            return state
    }
}
